export const WITHOUT_PO_DAYS_L0 = -1;
export const WITHOUT_PO_DAYS_L1 = 40;
export const WITHOUT_PO_DAYS_L2 = 55;
